import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {CustomProductsComponent} from './custom-products.component';
import { CustomProductsFilterBarComponent } from './custom-products-filter-bar/custom-products-filter-bar.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomProductsContentComponent } from './custom-products-content/custom-products-content.component';
import { CustomPortsContentComponent } from './custom-ports-content/custom-ports-content.component';
import { CustomProductTypeContentComponent } from './custom-product-type-content/custom-product-type-content.component';
import { CustomProductsBrowseAllContentComponent } from './custom-products-browse-all-content/custom-products-browse-all-content.component';
import { CustomProductCarouselComponent } from './custom-product-carousel/custom-product-carousel.component';
import { CustomProductCardComponent } from './custom-product-card/custom-product-card.component';
import { DragScrollComponent,DragScrollItemDirective } from 'ngx-drag-scroll';
import { ProductsListViewComponent } from './products-list-view/products-list-view.component';
import { ListCardComponent } from './list-card/list-card.component';
import { I18nModule } from '@spartacus/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BreadcrumbModule } from 'angular-crumbs-2';
import {SharedModule} from '../../../shared/shared.module';
//import { CouterOfferModalComponent } from '../counter-offer-modal/counter-offer-modal';
@NgModule({
    imports: [
        CommonModule,
        NgSelectModule,
        FormsModule,
        DragScrollComponent,
        DragScrollItemDirective,
        I18nModule,
        InfiniteScrollModule,
        ReactiveFormsModule,
        SharedModule,
        CustomProductsComponent, CustomProductsFilterBarComponent, CustomProductsContentComponent,
        CustomPortsContentComponent, CustomProductTypeContentComponent, CustomProductsBrowseAllContentComponent,
        CustomProductCarouselComponent, CustomProductCardComponent, ProductsListViewComponent, ListCardComponent
    ],
    exports: [ListCardComponent, CustomProductCardComponent]
})
export class CustomProductsModule { }
